<template>
    <modal v-show="show" @close="handleClose" size="larger" :closeable="true" class="outlined">
        <template #body>
            <div class="px-12" v-if="product">
                <div class="flex flex-wrap">
                    <div class="pr-6 w-full md:w-1/2">
                        <div class="featured text-center">
                            <img :src="'/storage/' + currentImage" class="image-large" />
                        </div>

                        <div class="gallery flex flex-wrap my-3" v-if="product.images">
                            <a href="#" @click.stop.prevent="handleSelectImage(product.image)">
                                <img :src="'/storage/' + product.image" class="image-thumbnail mr-1" />
                            </a>

                            <a v-for="image in product.images" :key="image.id" href="#" @click.stop.prevent="handleSelectImage(image.filename)">
                                <img :src="'/storage/' + image.filename" class="image-thumbnail mr-1" />
                            </a>
                        </div>
                    </div>

                    <div class="pr-6 w-full md:w-1/2">
                        <h3 v-text="product.title" class="mt-0 mb-6"></h3>

                        <p class="description mb-3" v-text="product.description"></p>

                        <div class="price mb-3">
                            ${{ product.price }} / {{ product.size }}
                        </div>

                        <p v-if="product.special_order" class="leading-tight !text-xs italic mb-3">SPECIAL ORDER 2 DAYS LEAD TIME</p>

                        <add-to-cart
                            v-if="isCustomer"
                            :product="product"
                            class="my-3 w-44"
                        />

                        <div class="mt-6" v-html="product.long_description"></div>
                    </div>
                </div>
            </div>
        </template>

        <template #footer></template>
    </modal>
</template>

<script>
    import { usePage } from '@inertiajs/inertia-vue3'
    import Modal from '@/Pages/Catalogue/Partials/Modal';
    import UseUserAuth from '@/Composables/UseUserAuth';
    import AddToCart from '@/Pages/Catalogue/Partials/AddToCart';

    export default {
        setup () {
            const { isCustomer } = UseUserAuth(usePage().props.value.user);

            return {
                isCustomer,
            }
        },

        components: {
            Modal,
            AddToCart,
        },

        props: ['product', 'show'],

        data () {
            return {
                currentImage: null,
            }
        },

        methods: {
            nl2br (str, is_xhtml) {
                if (typeof str === 'undefined' || str === null) {
                    return '';
                }
                var breakTag = (is_xhtml || typeof is_xhtml === 'undefined') ? '<br />' : '<br>';
                return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
            },

            handleSelectImage (image) {
                this.currentImage = image;
            },

            handleClose () {
                this.$emit('close');
            }
        },

        watch: {
            product () {
                this.currentImage = this.product.image;
            }
        },
    }
</script>

<style scoped>
    h3 {
        color: #000;
        font-size: 1.5rem;
        line-height: 1.2;
    }

    .unit {
        line-height: 1.2;
        color: #85C71E;
        font-weight: bold;
        font-size: 0.9rem;
    }

    .price {
        font-size: 1.375rem;
        color: #000;
    }

    @media (min-width: 1024px) {
        h3 {
            font-size: 2.125rem;
        }

        .price {
            font-size: 1.5rem;
        }
    }

    p {
        font-size: 16px;
    }

    .modal-container {
        padding: 30px;
    }

    .image-large {
        height: 180px;
        object-fit: cover;
        max-width: 100%;
    }

    @media (min-width: 1024px) {
        .image-large {
            height: auto;
            max-height: 360px;
        }
    }

    .image-thumbnail {
        width: 36px;
        height: 36px;
        object-fit: contain;
    }

    .gallery {
        text-align: center;
    }

    @media (min-width: 768px) {
        .gallery {
            text-align: left;
        }
    }
</style>